export default {"src":"/_next/static/media/internal-vulnerability-assessment.cfa0f44b.svg","height":538,"width":538,"blurWidth":0,"blurHeight":0};